import { Button, Col, DatePicker, Form, notification, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import dayjs from "dayjs";
import { CustomSpinner } from "../utils/CustomComponents";
const { RangePicker } = DatePicker;
const AssignRatePeerLoadModalByClient = ({
	onComplete,
	// startDate,
	// endDate,
}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [logisticsClientList, setLogisticsClientList] = useState([]);
	const [loadingButton, setLoadingButton] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getLogisticClients();
	}, []);

	const getLogisticClients = async () => {
		setLoading(true);
		const url = api + `/logistics/route/list`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: `${item.origin.name} -> ${item.destination.name}`,
					});
				});
				setLogisticsClientList(list);
				setLoading(false);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification(
				"error",
				"Error",
				"Errro while obtaning logistics client"
			);
			console.error(err.message);
			return null;
		}
	};

	const updateLogisticsTrips = async (values) => {
		setLoadingButton(true);

		const start = `${dayjs(values.dates[0]).year()}-${
			dayjs(values.dates[0]).month() + 1
		}-${dayjs(values.dates[0]).date()}`;
		const end = `${dayjs(values.dates[1]).year()}-${
			dayjs(values.dates[1]).month() + 1
		}-${dayjs(values.dates[1]).date()}`;

		const url =
			api +
			`/logisticstrip/update/rateload/byroute?startDate=${start}&endDate=${end}&routeId=${values.route}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url);

			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					setLoadingButton(false);
					onComplete();
				}, 1000);
			} else {
				setLoadingButton(false);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		updateLogisticsTrips(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					dates: [dayjs(), dayjs()],
				}}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Dates Range"
							name="dates"
							rules={[
								{
									required: true,
									message: "Dates are required",
								},
							]}
						>
							<RangePicker
								format={"MM/DD/YYYY"}
								size="large"
								disabled={loading}
								allowClear={false}
								style={{ width: "100%" }}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Route"
							name="route"
							rules={[
								{
									required: true,
									message: "Route is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select route"
								options={logisticsClientList}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Button
					type="primary"
					htmlType="submit"
					size="large"
					loading={loadingButton}
					disabled={loadingButton}
				>
					Send
				</Button>
			</Form>
		);
	};

	return (
		<>
			{loading ? <CustomSpinner /> : <CustomForm />} {contextHolder}
		</>
	);
};

export default AssignRatePeerLoadModalByClient;
